/**
 * PricingTableModal - Modal displaying Stripe pricing table for plan upgrades.
 */

import { Box, Center, Modal, Title } from "@mantine/core";
import type { PricingTableData } from "../types";

interface PricingTableModalProps {
  opened: boolean;
  onClose: () => void;
  pricingTableData: PricingTableData | null;
}

export const PricingTableModal = ({
  opened,
  onClose,
  pricingTableData,
}: PricingTableModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="70vw"
      title={<Title order={2}>Choose Your Plan</Title>}
      withCloseButton={true}
      radius={0}
      padding="24px"
    >
      <Center mih={400} w="100%" h="100%" mt={10}>
        {pricingTableData && (
          <Box w="100%" h="fit-content">
            <stripe-pricing-table
              pricing-table-id={pricingTableData["pricing-table-id"]}
              publishable-key={pricingTableData["publishable-key"]}
              customer-session-client-secret={
                pricingTableData["customer-session-client-secret"]
              }
            />
          </Box>
        )}
      </Center>
    </Modal>
  );
};
